var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2ExportHangupRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 18C20.8125 18 17.718 18.4695 14.8125 19.407V25.5945C14.8125 26.3445 14.343 27.189 13.6875 27.4695C11.718 28.407 9.93751 29.6265 8.34301 31.1265C7.96801 31.5015 7.49851 31.689 6.93601 31.689C6.37351 31.689 5.90401 31.5015 5.52901 31.1265L0.559509 26.157C0.184509 25.782 -0.00299072 25.3125 -0.00299072 24.75C-0.00299072 24.1875 0.184509 23.718 0.559509 23.343C6.65401 17.5305 14.904 13.968 23.997 13.968C33.09 13.968 41.3415 17.5305 47.4345 23.343C47.8095 23.718 47.997 24.1875 47.997 24.75C47.997 25.3125 47.8095 25.782 47.4345 26.157L42.465 31.1265C42.09 31.5015 41.6205 31.689 41.058 31.689C40.4955 31.689 40.026 31.5015 39.651 31.1265C38.0565 29.6265 36.276 28.407 34.3065 27.4695C33.6495 27.1875 33.1815 26.532 33.1815 25.6875V19.5C30.2745 18.5625 27.1815 18 23.994 18H24Z",
    fill: "#D4343E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2ExportHangupRed);
export default __webpack_public_path__ + "static/media/icon-2_export-HANGUP-RED.2c244aab330d6846f4fcd4c3ad9df9c1.svg";
export { ForwardRef as ReactComponent };